import { render, staticRenderFns } from "./modalCollection.vue?vue&type=template&id=1e25090b"
import script from "./modalCollection.vue?vue&type=script&lang=js"
export * from "./modalCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e25090b')) {
      api.createRecord('1e25090b', component.options)
    } else {
      api.reload('1e25090b', component.options)
    }
    module.hot.accept("./modalCollection.vue?vue&type=template&id=1e25090b", function () {
      api.rerender('1e25090b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/modal/modalCollection.vue"
export default component.exports